import React from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { ActiviteCollaborateurPanel } from '../components/ActiviteCollaborateurPanel';
import { Card, CardContent } from '../components/ui/card';

export const MonActivitePage = () => (
  <DashboardLayout>
    <div className="max-w-5xl mx-auto space-y-4" data-testid="mon-activite-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 font-['Plus_Jakarta_Sans']">Mon activité</h1>
        <p className="text-sm text-slate-500">Vos journées du mois : formations, activités déclarées et pointage optionnel (heures de début / fin).</p>
      </div>
      <Card className="border-0 shadow-sm"><CardContent className="p-5"><ActiviteCollaborateurPanel mode="self" /></CardContent></Card>
    </div>
  </DashboardLayout>
);
